import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'checkbox',
    template: `
        <div [formGroup]="form">
        <div  style="margin-left: 10px;">
        <div *ngIf="!field.value">
          <div *ngFor="let opt of field.options" class="form-check form-check">
          <label class="form-check-label">
             <input [formControlName]="opt.key" class="form-check-input" type="checkbox" id="inlineCheckbox1" />
             {{opt.label}}
            </label>           
          </div>
        </div>
        </div>
        <span style="margin-left: 10px;" *ngIf="field.value">
        <i class="fa fa-arrow-right"></i> &nbsp;{{field.value}}</span>
      </div> 
    `
})
export class CheckBoxComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }

    constructor(){
      //console.log(this.field);
      
    }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/atoms/checkbox.ts